module.exports = __webpack_public_path__ + "img/icon.69d3481b.svg";